import React from 'react';

import BaseIcon from './base';
import path from '../../../assets/Dashboard/eBike.svg';

export default function EBikeSvgIcon({ classes }) {
  return (
    <BaseIcon classes={classes} altText="scooter" path={path} />
  );
}
